import { useContext } from 'react';
import AppContext from '../Contexts/AppContext';
import { FEATURE_GATING_STATUS } from '../Constants/Common';
import { useCheckFeatureGating } from '../HOC/withPlanFeatureGating';

const checkMDMVisibility = (
  appContext,
  mdmFeature,
  includeTrialStates = false
) => {
  const customerSource = appContext?.user?.customer?.source?.name;
  const loadRMMAppProperties =
    appContext?.rmmProperties?.['rmm.policyManagementType'];

  const allowedStatuses = includeTrialStates
    ? [
        FEATURE_GATING_STATUS.ENABLED,
        FEATURE_GATING_STATUS.IN_TRIAL,
        FEATURE_GATING_STATUS.TRIAL_ELIGIBLE,
        FEATURE_GATING_STATUS.EXPIRED
      ]
    : [FEATURE_GATING_STATUS.ENABLED, FEATURE_GATING_STATUS.IN_TRIAL];

  const hasValidStatus = allowedStatuses.includes(mdmFeature?.status);
  const isNotAssetGroup = loadRMMAppProperties !== 'ASSET_GROUP';
  const isNotPax8 = customerSource !== 'PAX8';

  return hasValidStatus && isNotAssetGroup && isNotPax8;
};

const useMDMVisibility = (includeTrialStates = false) => {
  const appContext = useContext(AppContext);
  const mdmFeature = useCheckFeatureGating('MDM');

  return checkMDMVisibility(appContext, mdmFeature, includeTrialStates);
};

export { checkMDMVisibility, useMDMVisibility };
